<template>
    <div class="background-picker">
        <list-select :options="backgroundTypes" :value="value.type" @input="onChange" />
        <color-picker :label="label" v-if="value.type==='color'" :color="value.value" @input="(color)=>{setBackground('color',color)}" />
        <gradient-picker :label="label" v-if="value.type==='gradient'" @input="(gradient)=>{setBackground('gradient',gradient)}" />
        <!-- <image-picker :label="label" v-if="value.type==='image'" :image="value.value" @input="(image)=>{setBackground('image',image)}" /> -->


        
    </div>
</template>
<script>
import ColorPicker from "./color-picker.vue";
import GradientPicker from "./gradient-picker.vue";
import ImagePicker from "./image-picker.vue";
export default {
    name: "background-picker",
    components: { ColorPicker, GradientPicker, ImagePicker },
    props: {
        value: {
            type: Object,
            default: function() { return { type: 'color', value: "transparent" } }
        },
        label: String
    },
    methods: {
        setColor(value) {
            this.$emit('input', {
                type: "color",
                value
            });
        },
        setBackground(type, value) {
            this.$emit('input', { type, value });
        },
        onChange(backgroundType) {
            this.$emit('input', {
                type: backgroundType,
                value: ({
                    color: '#4088ff',
                    gradient: {
                        "angle": 135,
                        "computed": "linear-gradient(135deg,#0089FF 0%,#004980 100%)",
                        "points": [
                          {
                            "color": "#0089FF",
                            "position": 0
                          },
                          {
                            "color": "#004980",
                            "position": 100
                          }
                        ]
                    },
                    image: 'url(https://static.pexels.com/photos/242616/pexels-photo-242616.jpeg)'
                })[backgroundType]
            });
        }
    },
    data() {
        return {
            backgroundTypes: [
                { label: "Прозрачный", value: "transparent" },
                { label: "Цвет", value: "color" },
                { label: "Градиент", value: "gradient" },
                //{ label: "Изображение", value: "image" },
            ]
        }
    }
}
</script>
<style scoped>
.background-picker {}

</style>